import { Component, OnInit, HostListener } from '@angular/core';
import * as d3 from "d3";
import { common } from 'src/app/common/common';

@Component({
  selector: 'mri-bulletsavinghrs-chart',
  templateUrl: './savinghrs-bullet-chart.component.html',
  styleUrls: ['./savinghrs-bullet-chart.component.scss']
})
export class SavingHrsBulletChartComponent implements OnInit {

  data: any;
  selector = "bullet-chart-section-savinghrs";
  margin = { top: 10, bottom: 20, left: 10, right: 10 };
  svg: any;
  width: number;
  height: number;
  graphWidth: number;
  chart: any;
  bar_width =8;
  rx = this.bar_width / 2;
  ry = this.bar_width / 2;
  rangeVal = [50, 40, 30, 20, 10];
  rangeColor = ['#F0F0F1', '#e3e6e8', '#cbd0d6', '#bac0cc', '#aab0bd'];
  legendKey = ["Planned", "Completed"];
  legendColor = ["#9657D5", "#B95FD2"];
  xAxisLabel = "Total Savings ($)";

  constructor() { }

  ngOnInit() {
    //common.clearSVG(this.selector);
    this.drawGraph();
  }

  getData() {
    return [{ 
      "title":"Actual",
      "measures": 9,
      "markers": 15
    }];
  }

  renderSVGContainer() {
    let elem = <HTMLElement>(
      document.getElementsByClassName(this.selector)[0]
    );
    elem.innerHTML = "";
    this.width = 190; // elem.offsetWidth-20 ;

    this.height = 80 ;

    this.svg = common.getSVG(this.selector, this.width - 20, this.height-10);

    this.graphWidth = this.width;
   // this.svg = common.getSVG(this.selector, '80', '80');

    // this.width = 100 //elem.offsetWidth - this.margin.left - this.margin.right;
    // this.height = 100; //elem.offsetHeight - this.margin.top - this.margin.bottom;

    // this.graphWidth = 100;
  }

  xScale() {
    return d3.scaleLinear()
      .range([0, this.graphWidth])
      .domain([0, 50])
      .nice();
  }

  yScale() {
    return d3.scaleBand()
      .range([0, this.height])
      .padding(0.2);
  }

  renderChartContainer() {
    return this.chart = this.svg
    .append("g")
    .attr(
      "transform",
      "translate(" + [this.margin.left , this.margin.top - 70] + ")"
    );
  }

  renderXAxis() {
    this.renderChartContainer().append("g")
      .attr("transform", `translate(0 , ${this.height + 10})`)
      .call(d3.axisBottom(this.xScale()).tickSizeOuter(0)
          .ticks(6).tickFormat( d => d > 0 ? d + 'K': '0K'))
      .call((d) => {
        d.selectAll("path").remove();
        d.selectAll("line").remove();
        d.selectAll("text")
          .attr("font-size", "10px")
      });
  }

  renderRangeRect() { 
    var range = this.renderChartContainer()
      .selectAll()
      .data(this.rangeVal)
      .enter()    
      .append("g")
      
    range.append('rect')
      .attr('class', 'in-range')
      .attr("x", -5)
      .attr('y', this.yScale().bandwidth() - this.rx * 2 - 2)
      .attr('height', this.bar_width * 3)
      .attr('width', (d) => this.xScale()(d) + 8)
      .attr('fill', (d, i) => this.rangeColor[i]);    

    range.append('rect')
      .attr('class', 'out-range')
      .attr("x", -5)
      .attr('y', this.yScale().bandwidth() - this.rx * 2 - 2)
      .attr('rx', this.rx)
      .attr('ry', this.ry)
      .attr('height', this.bar_width * 3)
      .attr('width', this.graphWidth + 8)
      .attr('fill', 'none')
      .attr('stroke', 'white')
      .attr('stroke-width', 8);
  }

  renderMeasure() {
    var mes = this.renderChartContainer()
      .selectAll()
      .data(this.data)
      .enter()    
      .append("g")
      .attr("class", "measure")
      .style("fill", this.legendColor[1]);
  
    mes.append("path")
      .attr("d", (d, i) => {
        return `M${0} ${this.yScale().bandwidth() - this.ry + 4}
              h${this.xScale()(d.measures) - this.rx}
              a${this.rx} ${this.ry} 0 0 1 ${this.rx} ${this.ry}
              v 4
              a${this.rx} ${this.ry} 0 0 1 ${-this.rx} ${this.ry}
              h${-(this.xScale()(d.measures) - this.rx)}Z`
      }
      )
  }

  renderMark() {
    let mark = this.renderChartContainer()
      .selectAll(".marker")
      .data(this.data)
      .enter()
      .append('g')      
      .attr("class", "marker")

    mark.append("line")
      .attr("x1", d => this.xScale()(d.markers))
      .attr("x2", d => this.xScale()(d.markers))
      .attr("y1", this.yScale().bandwidth() - this.bar_width + 2)
      .attr("y2", this.yScale().bandwidth() + this.bar_width + 10)
      .attr("stroke-width", 3)
      .attr("stroke", this.legendColor[0])
      .attr('fill', this.legendColor[0]);
  }

  renderAxisText() {
    this.renderChartContainer().append("text")
      .attr("transform",
        "translate(" + (this.graphWidth / 2) + " ," + (this.height + 70) + ")")
      .attr("text-anchor", "middle")
      .attr("font-family", "sans-serif Medium")
      .attr("font-size", "12px")
      .text(this.xAxisLabel);
  }


  renderLegend() {
    var nodeWidth = (d) => d.getBBox().width;
    const legend = this.renderChartContainer().append('g')
      .attr('class', 'legend')
      .attr('transform', 'translate(0,0)');

    const lg = legend.selectAll('g')
      .data(this.legendKey)
      .enter()
      .append('g')
      .attr("class", (d,i) => "circlelegend"+i)

    lg.append('circle')
      .attr("id", (d,i) => "circle"+i)
      .attr('fill', (d, i) => this.legendColor[i])
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('r', 5)

    lg.append('text')
      .attr("font-family", "sans-serif")
      .attr("font-size", "11px")
      .attr('fill', '#515151')
      .attr('x', 10)
      .attr('y', 5)
      .attr('dy', -1)
      .text((d, i) => this.legendKey[i]);

    let offset = 0;
    const self = this;
    lg.attr('transform', function (d, i) {
      let x = offset;
      offset += nodeWidth(this) + 10;
      return `translate(${x},${self.height + 10})`;
    });

    legend.attr('transform', function () {
      return `translate(${(self.graphWidth - nodeWidth(this)) / 2},${90})`
    });       
  }

  drawGraph() {
    this.data = this.getData();
    this.renderSVGContainer();
    this.renderXAxis();
    this.renderRangeRect();
    this.renderMeasure();
    this.renderMark();
    this.renderAxisText();
    this.renderLegend();     
  }

  // @HostListener("window:resize", ["$event"])
  // onResize(event) {
  //   common.clearSVG(this.selector);
  //   this.drawGraph();
  // }
}
